export default IconQuotes => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-quotes" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 12c-1.333 -1.854 -1.333 -4.146 0 -6" />
  <path d="M8 12c-1.333 -1.854 -1.333 -4.146 0 -6" />
  <path d="M16 18c1.333 -1.854 1.333 -4.146 0 -6" />
  <path d="M20 18c1.333 -1.854 1.333 -4.146 0 -6" />
</svg>`;